import styled from '@emotion/styled';

export const SwitchGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.savory.spacing[2]};
`;
